import { Col, Form, Row } from "react-bootstrap";
import InputPriceRate from "components/others/InputPriceRate";
import { useTranslation } from "react-i18next";
import { TeamSelect } from 'modules/user';
import { useEffect, useRef } from "react";
import ExpendTypeSelect from "../../ExpendTypeSelect";
import { ServicesSelect } from 'modules/product';

const AddServiceForm = ({values, setFieldValue, handleSubmit, isSubmitting, titleAmount, forTeam=true, income = true}) => {
    const { t } = useTranslation(['Objects']);
    const refInputAmount = useRef();
    const isCustom = Boolean(values?.isCustom);

    useEffect(()=>{
        if (refInputAmount.current && !forTeam) {
            refInputAmount.current.focus();
            refInputAmount.current.select();         
        } 
    }, [refInputAmount, forTeam])

    if (!forTeam) {
        return (
            <form onSubmit={handleSubmit}>
                <Row>
                    <Col lg={6}>
                        <div className="mb-3"> 
                            <label className="form-label text-muted">{titleAmount}</label>
                            <InputPriceRate 
                                allowNegative={false}
                                disabled={isSubmitting}
                                ref={refInputAmount}
                                value={values?.amount}
                                onValueChange={(val) =>
                                    setFieldValue('amount', val.value)}/>
                        </div>
                    </Col>
                    <Col lg={6}>
                        <ExpendTypeSelect
                            disabled={isSubmitting}
                            value={values?.expendTypeId}
                            income={income} 
                            onChange={(opt)=>{
                                setFieldValue('expendTypeId', opt.value)}}/>
                    </Col>
                </Row>
     
                <div> 
                    <div className="mb-3">
                        <label className="form-label text-muted">{t('addService.labelDescription')}</label>
                        <textarea
                            className="form-control"
                            rows={4}
                            disabled={isSubmitting}
                            value={values.description||''}
                            onChange={(e)=> setFieldValue('description', e.target.value)}/>
                    </div>
                </div>
            </form>
        )
    }

    return (
        <form onSubmit={handleSubmit}>
            <div className="mb-3 d-flex gap-3 flex-wrap">
                <Form.Check
                    type="radio"
                    id="service-mode-manual"
                    name="serviceMode"
                    label={t('addService.modeCustom')}
                    checked={isCustom}
                    disabled={isSubmitting}
                    onChange={() => {
                        setFieldValue('isCustom', true);
                        setFieldValue('serviceId', null);
                    }}
                />
                <Form.Check
                    type="radio"
                    id="service-mode-catalog"
                    name="serviceMode"
                    label={t('addService.modeCatalog')}
                    checked={!isCustom}
                    disabled={isSubmitting}
                    onChange={() => {
                        setFieldValue('isCustom', false);
                        setFieldValue('serviceId', null);
                        setFieldValue('name', '');
                    }}
                />
            </div>

            {isCustom ? (
                <div className="mb-3">
                    <label className="form-label text-muted">{t('addService.labelName')}</label>
                    <input
                        autoFocus
                        type="text"
                        className="form-control"
                        disabled={isSubmitting}
                        value={values?.name || ''}
                        onChange={(e) => setFieldValue('name', e.target.value)}
                    />
                </div>
            ) : (
                <div className="mb-3">
                    <ServicesSelect
                        disabled={isSubmitting}
                        required={false}
                        value={values?.serviceId}
                        onChange={(opt) => {
                            if (!opt) {
                                setFieldValue('serviceId', null);
                                setFieldValue('name', '');
                                return;
                            }
                            setFieldValue('serviceId', opt.value);
                            setFieldValue('name', opt.label || '');
                            setFieldValue('price', opt.defPrice ?? 0);
                            setFieldValue('priceSale', opt.defPriceSale ?? 0);
                        }}
                    />
                </div>
            )}

            <Row>
                <Col lg={4}>
                    <div className="mb-3">
                        <label className="form-label text-muted">{t('addService.labelCount')}</label>
                        <input
                            type="number"
                            min="0"
                            step="any"
                            className="form-control"
                            disabled={isSubmitting}
                            value={values?.count ?? 1}
                            onChange={(e) => setFieldValue('count', e.target.value)}
                        />
                    </div>
                </Col>
                <Col lg={4}>
                    <div className="mb-3">
                        <label className="form-label text-muted">{t('addService.labelPrice')}</label>
                        <InputPriceRate
                            allowNegative={false}
                            disabled={isSubmitting}
                            value={values?.price}
                            onValueChange={(val) => setFieldValue('price', val.value)}
                        />
                    </div>
                </Col>
                <Col lg={4}>
                    <div className="mb-3">
                        <label className="form-label text-muted">{t('addService.labelPriceSale')}</label>
                        <InputPriceRate
                            allowNegative={false}
                            disabled={isSubmitting}
                            value={values?.priceSale}
                            onValueChange={(val) => setFieldValue('priceSale', val.value)}
                        />
                    </div>
                </Col>
            </Row>

            <Row>
                <Col lg={6}>
                    <TeamSelect
                        disabled={isSubmitting}
                        isClearable
                        value={values?.teamId || null}
                        onChange={(opt)=>{
                            setFieldValue('teamId', opt?.value || null)}}/>
                </Col>
            </Row>
 
            <div className="mt-3"> 
                <div className="mb-3">
                    <label className="form-label text-muted">{t('addService.labelDescription')}</label>
                    <textarea
                        className="form-control"
                        rows={3}
                        disabled={isSubmitting}
                        value={values.description||''}
                        onChange={(e)=> setFieldValue('description', e.target.value)}/>
                </div>
            </div>
        </form>
    )
}

export default AddServiceForm;
